<template>
  <v-app id="inspire">
    <v-app-bar app elevation="0">
      <v-subheader class="text-center justify-center align-center"><h1 class="green--text">Politik<span
          class="pink--text">.sms</span></h1></v-subheader>
      <v-spacer class="hidden-sm-and-down"/>
      <v-btn text large exact color="green" to="/" class="white--text ml-2 hidden-sm-and-down">Home</v-btn>
      <v-btn text large exact color="green" to="/politik.check" class="white--text ml-2 hidden-sm-and-down">Polls</v-btn>
      <v-btn text large exact color="green" to="/politik-results" class="white--text ml-2 hidden-sm-and-down">Poll Results</v-btn>
      <v-btn text large exact color="green" to="/login" class="white--text ml-2 hidden-sm-and-down">Login</v-btn>
    </v-app-bar>
    <v-main style="background-color: #fafafa">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'homeLayout',

  data: () => ({
    drawer: null,
  }),
}
</script>
<style>
.v-tab.active-tab {
  color: #e91e63;
}

.v-tab.active-tab::before {
  background-color: #4caf50;
}
</style>